import { render, staticRenderFns } from "./DelightedLoader.vue?vue&type=template&id=153f8b69&scoped=true"
import script from "./DelightedLoader.vue?vue&type=script&lang=js"
export * from "./DelightedLoader.vue?vue&type=script&lang=js"
import style0 from "./DelightedLoader.vue?vue&type=style&index=0&id=153f8b69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153f8b69",
  null
  
)

export default component.exports